import {StyleSheet, css} from 'aphrodite';
import React from 'react';

import {ChatType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {Chat} from 'llm/chat-library/Chat';
import {useChatSessionEvents} from 'llm/chat-library/useChatSessionEvents';

interface ReadOnlyChatProps {
  chatId: string;
  isExpanded: boolean;
}

export function ReadOnlyChat(props: ReadOnlyChatProps): JSX.Element {
  const {chatId, isExpanded} = props;

  const {chatType} = useChatSessionEvents({
    chatSessionId: chatId,
    includeToolCalls: false,
  });

  const footerMessage = (
    <div className={css(styles.footerMessage)}>
      <p>This is a read-only chat. To send a message, please create a new chat.</p>
    </div>
  );

  return (
    <div className={css(styles.contentContainer)}>
      <Chat
        chatSessionId={chatId}
        chatType={chatType ?? ChatType.DEEP_RESEARCH}
        isExpanded={isExpanded}
        locked={true}
      />
      {footerMessage}
    </div>
  );
}

const styles = StyleSheet.create({
  footerMessage: {
    fontSize: '10px',
    textAlign: 'center',
    marginTop: '4px',
    marginBottom: '4px',
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    minHeight: 0,
    flex: 1,
  },
});

export default ReadOnlyChat;
